import React from 'react';
import { useGame } from '../context/GameContext';
import { ACHIEVEMENTS, ACHIEVEMENT_IDS } from '../game/achievements';
import { ArrowLeft, Award, Lock } from 'lucide-react';

export default function Achievements() {
  const { profile, setScreen } = useGame();
  const earned = new Set(profile?.achievements || []);
  const total = ACHIEVEMENT_IDS.length;
  const earnedCount = ACHIEVEMENT_IDS.filter(id => earned.has(id)).length;

  return (
    <div className="min-h-screen w-full px-6 py-6" data-testid="achievements-screen">
      <div className="flex items-center justify-between">
        <button className="brutal-btn text-sm" onClick={() => setScreen('menu')} data-testid="ach-back">
          <ArrowLeft size={16}/> BACK
        </button>
        <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-[color:var(--neon)] flex items-center gap-3">
          <Award/> ACHIEVEMENTS
        </h1>
        <div className="text-xs uppercase text-[color:var(--text-dim)]" data-testid="ach-progress">
          {earnedCount}/{total}
        </div>
      </div>

      <div className="mt-4 h-2 bg-[#111] brutal-border-dim" data-testid="ach-progress-bar">
        <div className="h-full bg-[color:var(--neon)]" style={{ width: `${(earnedCount / Math.max(1, total)) * 100}%`, minWidth: '2px' }} data-testid="ach-progress-fill"/>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
        {ACHIEVEMENT_IDS.map(id => {
          const a = ACHIEVEMENTS[id];
          const got = earned.has(id);
          return (
            <div key={id} className={`brutal-border p-4 flex items-center gap-4 ${got ? '' : 'opacity-40'}`}
              data-testid={`ach-${id}`} data-earned={got ? 'true' : 'false'}>
              {got ? <Award size={24} style={{ color: 'var(--neon)' }}/> : <Lock size={24}/>}
              <div className="flex-1">
                <div className="font-display font-black uppercase text-sm">{a.name}</div>
                <div className="text-xs text-[color:var(--text-dim)] mt-1">{a.desc}</div>
                {a.title && <div className="text-[10px] text-[color:var(--pink)] mt-1 uppercase">TITLE: {a.title}</div>}
              </div>
              <div className="text-xs font-mono text-[color:var(--pink)]">+{a.tokens}🪙</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
